import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class AppRouteReuseStrategy implements RouteReuseStrategy {
    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig && future.paramMap.get('app') === curr.paramMap.get('app') && future.paramMap.get('spaceId') === curr.paramMap.get('spaceId') && future.paramMap.get('appId') === curr.paramMap.get('appId') && future.paramMap.get('entityId') === curr.paramMap.get('entityId') && future.paramMap.get('subEntityId') === curr.paramMap.get('subEntityId');
    }
    public shouldDetach(_route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    public store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle): void {
        // Do nothing
    }
    public shouldAttach(_route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    public retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle {
        return null;
    }
}
